import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import PreviewRowTabular from './PreviewRowTabular';

const STRETCH_THRESHOLD = 3;
const PREVIEW_LIMIT = 3;

const PreviewTableTabularInput = ({ rows }: { rows: string[][] }) => {
  const previewRows = React.useMemo(() => rows.slice(0, PREVIEW_LIMIT), [rows]);

  const columnsCount = React.useMemo(() => Math.max(1, ...rows.map(r => r.length)), [rows]);

  const hasManyColumns = columnsCount > STRETCH_THRESHOLD;
  const hasMoreRows = rows.length > PREVIEW_LIMIT;

  return (
    <Box>
      <Box position="relative" overflow="hidden">
        <Paper variant="outlined">
          {previewRows.length === 0 && (
            <Box p={1} textAlign="center">
              <Typography variant="body1">No data</Typography>
            </Box>
          )}

          {previewRows.map((row, index) => (
            <PreviewRowTabular
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              row={row}
              isLast={index === previewRows.length - 1}
              hasManyColumns={hasManyColumns}
            />
          ))}
        </Paper>

        {hasManyColumns && (
          <Box
            sx={{
              pointerEvents: 'none',
              position: 'absolute',
              top: 0,
              right: 0,
              width: 40,
              height: '100%',
              background:
                'linear-gradient(to right, var(--mui-palette-common-transparentWhite), var(--mui-palette-common-white))',
            }}
          />
        )}
      </Box>

      {hasMoreRows && (
        <Typography variant="body2" color="textSecondary" mt={0.5} display="block">
          +{rows.length - PREVIEW_LIMIT} more rows…
        </Typography>
      )}
    </Box>
  );
};

export default PreviewTableTabularInput;
